import React, { createContext, useState, useContext, useEffect } from "react";
import apiPath from "../constants/apiPath";
import axios from "axios";

export const AppStateContext = createContext();

export const AppContextProvider = ({ children }) => {

  // ── Shared weekly plan — single source of truth for Dashboard + Programme ──
  // Both pages read from and write to this state.
  // Any save from either page immediately updates the other.
  const [weeklyPlan, setWeeklyPlan] = useState(null);

  const [pageHeading, setPageHeading] = useState("Heading");
  const [language, setLanguage] = useState("en");
  const [loading, setLoading] = useState(true);
  const [logs, setLogs] = useState([]);
  const [logsCount, setLogsCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [unreadNotiCount, setUnreadNotiCount] = useState(0);
  const [refreshAppContext, setRefreshAppContext] = useState(false);
  const [country, setCountry] = useState({
    country_id: undefined,
    currency: undefined,
    data: undefined
  });


  const getActivityLogs = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(apiPath.baseURL + "admin/change-log", {
        headers,
      });
      const data = response.data?.data

      if (data) {
        const filterData = data?.length && data?.filter((item) => item?.is_read === false)
        setLogs(filterData.slice(0, 5));
        setLogsCount(filterData?.length ?? 0)
        setRefreshAppContext(false)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchNotiData = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(apiPath.baseURL + "common/notify", {
        headers,
      });
      const data = response.data?.data

      if (data) {
        let unread = data?.notifications?.filter((item) => item?.is_read === false)
        setNotifications(unread);
        setUnreadNotiCount(data.unreadCount);
      }
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {
    getActivityLogs()
    fetchNotiData()
  }, [refreshAppContext])

  useEffect(() => {
    setLoading(true)
    let lang = localStorage.getItem("languageSet")
    lang = lang ? lang : 'en';

    if (lang == "ar") {

      import('../assets/styles/rtl.css')

    } else {
      import('../assets/styles/main.css')
    }

    setTimeout(() => setLoading(false), 200)
    setLanguage(lang)
  }, [])

  return (
    <AppStateContext.Provider
      value={{
        weeklyPlan,
        setWeeklyPlan,
        pageHeading,
        setPageHeading,
        setCountry,
        country,
        language,
        setLanguage,
        logsCount,
        logs,
        refreshAppContext,
        setRefreshAppContext,
        unreadNotiCount,
        notifications
      }}
    >
      {loading ? null : children}
    </AppStateContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppStateContext);
};

